import { TEAM_ROOT } from '@/domains/admin';

/**
 * Where the mock screens live. Each sits under `/team`, in the zone it belongs to, and is mounted
 * only while the demo is on: with it off, every one of these addresses falls to its zone's
 * catch-all, exactly as an unknown address does.
 *
 * Spelled here, not in the zones' own path tables, so that no product module names an address the
 * product does not have. Nothing sits beside the front door any more: team registration, the one
 * anonymous mock, went live with SR-213's teams block and its address (`/demo/registration/team`)
 * falls to the catch-all like any unknown one. Teams, Firms (SR-414), Metrics updates (SR-315) and
 * Setup's Templates (SR-523) went live at the very addresses their mocks held, and the mocks were
 * deleted.
 */
export const DEMO_PATHS = {
  // Kept where it stood beside the worklists mock, deleted with SR-230 (the Lists design's Q3).
  initialReview: `${TEAM_ROOT}/worklists/initial-review`,
  // Its own address since the live Rankings (SR-231) took `/team/rankings`.
  rankings: `${TEAM_ROOT}/rankings-mock`
} as const;
